import { Seo } from "@/components/Seo";

const PolicyLayout = ({ title, testid, children }) => (
  <div data-testid={testid} className="mx-auto max-w-3xl px-6 py-16">
    <h1 className="font-display text-4xl font-black tracking-tight text-slate-800 sm:text-5xl">{title}</h1>
    <div className="mt-8 space-y-6 text-base font-semibold leading-relaxed text-slate-600">
      {children}
    </div>
    <p className="mt-10 text-sm font-semibold text-slate-400">Last updated: October 2026</p>
  </div>
);

export function PrivacyPolicy() {
  return (
    <PolicyLayout title="Privacy Policy" testid="privacy-page">
      <Seo title="Privacy Policy | Divine Kids Learning" description="How Divine Kids Learning collects and protects your information." />
      <p>Divine Kids Learning respects your privacy. This policy explains what information we collect and how we use it.</p>
      <h2 className="font-display text-2xl font-bold text-slate-800">What we collect</h2>
      <p>When you place an order we collect your name, email address and (optionally) phone number so your purchase can be delivered. When you contact us, we collect your name, email and message.</p>
      <h2 className="font-display text-2xl font-bold text-slate-800">How we use it</h2>
      <p>We use your information only to deliver your digital products, send your download links, respond to your messages, and improve our store. We never sell or share your personal information with third parties for marketing.</p>
      <h2 className="font-display text-2xl font-bold text-slate-800">Payments</h2>
      <p>Payments are processed securely by our payment partner (SuperProfile/Cosmofeed) on their checkout page. We never see or store your card or UPI details.</p>
      <h2 className="font-display text-2xl font-bold text-slate-800">Your choices</h2>
      <p>You can ask us to update or delete your information anytime through our Contact page.</p>
    </PolicyLayout>
  );
}

export function TermsConditions() {
  return (
    <PolicyLayout title="Terms & Conditions" testid="terms-page">
      <Seo title="Terms & Conditions | Divine Kids Learning" description="Terms of use for Divine Kids Learning digital products." />
      <h2 className="font-display text-2xl font-bold text-slate-800">Digital products</h2>
      <p>All products sold on Divine Kids Learning are digital PDF downloads. No physical item will be shipped. After successful payment, your PDF is delivered automatically by email.</p>
      <h2 className="font-display text-2xl font-bold text-slate-800">License</h2>
      <p>Your purchase gives you a non-exclusive license for personal use, home learning, and use in your own classroom. You may not resell, redistribute, or share the PDF files publicly or commercially.</p>
      <h2 className="font-display text-2xl font-bold text-slate-800">Payments</h2>
      <p>Prices are listed in Indian Rupees (INR). Payments are processed securely by our payment partner (SuperProfile/Cosmofeed). Once payment succeeds, your download is delivered automatically.</p>
    </PolicyLayout>
  );
}

export function RefundPolicy() {
  return (
    <PolicyLayout title="Refund Policy" testid="refund-page">
      <Seo title="Refund Policy | Divine Kids Learning" description="Refund policy for Divine Kids Learning digital downloads." />
      <p>Because our products are digital PDF downloads, all sales are generally final once the PDF has been downloaded.</p>
      <h2 className="font-display text-2xl font-bold text-slate-800">When we can help</h2>
      <p>If you were charged but did not receive your download, received the wrong file, or the file will not open, contact us through the Contact page and we will make it right — with a working file or a refund.</p>
      <h2 className="font-display text-2xl font-bold text-slate-800">Duplicate payments</h2>
      <p>If you accidentally paid twice for the same order, contact us with both transaction references and we will refund the duplicate payment.</p>
    </PolicyLayout>
  );
}
